var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69.175606,
    height: 68,
    viewBox: "0 0 69.175606 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g1319",
    transform: "translate(71.831614,6.4565717)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g1221",
    transform: "translate(-73.243823,-6.4565717)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.1213,56.8787 C 11.6839,56.3161 12.447,56 13.2426,56 h 45.5148 c 0.7956,0 1.5587,0.3161 2.1213,0.8787 l 9.4142,9.4142 C 70.9229,66.9229 70.4767,68 69.5858,68 H 2.41422 C 1.52331,68 1.07714,66.9229 1.70711,66.2929 Z",
    fill: "#e62645",
    id: "path1209"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 59.5,25.8333 c 0,3.1575 -1.4576,6.9161 -3.8485,10.8979 -2.3699,3.9469 -5.5521,7.9429 -8.7689,11.535 -3.2117,3.5863 -6.428,6.737 -8.8438,8.9927 -1.207,1.127 -2.2119,2.0286 -2.9135,2.647 -0.0429,0.0378 -0.0847,0.0746 -0.1253,0.1103 -0.0406,-0.0357 -0.0824,-0.0725 -0.1253,-0.1103 -0.7016,-0.6184 -1.7065,-1.52 -2.9135,-2.647 -2.4158,-2.2557 -5.6321,-5.4064 -8.8438,-8.9927 -3.2168,-3.5921 -6.399,-7.5881 -8.7689,-11.535 C 11.9576,32.7494 10.5,28.9908 10.5,25.8333 10.5,12.4035 21.4599,1.5 35,1.5 c 13.5401,0 24.5,10.9035 24.5,24.3333 z",
    fill: "#ef7c00",
    stroke: "#ffeadb",
    strokeWidth: 3,
    id: "path1211"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g1312",
    transform: "translate(-48.196595,9.3981218)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 0.593376,8.55068 C -0.671461,9.80914 0.219766,11.9685 2.00401,11.9685 h 0.44675 v 7.0283 c 0,1.1045 0.89543,2 2,2 H 15.5738 c 1.1045,0 2,-0.8955 2,-2 v -7.0283 h 0.4479 c 1.7842,0 2.6754,-2.15936 1.4106,-3.41782 L 11.4235,0.582217 c -0.7802,-0.77629 -2.04107,-0.776289 -2.8213,2e-6 z M 9.74373,14.9778 c -1.10457,0 -2,0.8955 -2,2 v 4.0187 h 4.53687 v -4.0187 c 0,-1.1045 -0.8954,-2 -2,-2 z",
    fill: "#ffeadb",
    id: "path1303"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAddress);
export default __webpack_public_path__ + "static/media/imgAddress.53313484adeee51368403e901941a68b.svg";
export { ForwardRef as ReactComponent };